import { Box, Button, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useLocation, useNavigate } from 'react-router-dom';
import date from '../../../assets/icons/e-learning/user/date.svg'
import ment from '../../../assets/icons/e-learning/user/comment.svg'
import book from '../../../assets/icons/e-learning/user/book_orange.svg'
import time from '../../../assets/icons/e-learning/user/time_orange.svg'
import arrow from '../../../assets/icons/e-learning/arrow.svg'
import key from '../../../assets/icons/e-learning/user/key.svg'
import ReactPlayer from 'react-player';
import * as api from '../../services/api'
import Loader from 'components/Loader';

import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';

function Classroom() {
    const location = useLocation()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const [inform, setInform] = useState([])
    const [property, setProperty] = useState([])
    const [open, setOpen] = useState(Array.from(property, () => false));

    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
    const [watchedVideos, setWatchedVideos] = useState([]);

    const [complete, setComplete] = useState(0)
    const [showColor, setShowColor] = useState(0)

    const [groupCode, setGroupCode] = useState('')
    const [code, setCode] = useState('')
    const [registerNumber, setRegisterNumber] = useState(null)

    const playerRef = useRef(null)
    const [playing, setPlaying] = useState(false)
    const [playedSeconds, setPlayedSeconds] = useState(0)
    const [duration, setDuration] = useState(0)


    useEffect(() => {
        let detail = location.state.item
        setInform(detail)
        setProperty(detail['properties'])
        setGroupCode(detail['e_learning_group_code'])
        setCode(detail['e_learning_code'])
        // console.log(detail)

        let number = location.state.register_number
        setRegisterNumber(number)

        let current = location.state.current
        console.log(location.state)
        setWatchedVideos([])
        if (current) {
            setCurrentVideoIndex(current)
            setComplete(current)
            setShowColor(current)

            for (let i = 0; i < current; i++) {
                setWatchedVideos((prev) => [...prev, i]);
            }
            // setWatchedVideos((prev) => [...prev, current - 1]);
        }

    }, [])

    const toggle = (index, value) => {
        const newOpenState = [...open]
        newOpenState[index] = value ?? !newOpenState[index]
        setOpen(newOpenState)
    }

    console.log(watchedVideos)

    const handleVideoEnd = () => {
        setPlaying(false)

        if (!watchedVideos.includes(currentVideoIndex)) {
            setWatchedVideos((prev) => [...prev, currentVideoIndex]);
            setComplete(currentVideoIndex + 1)

            finishLesson(currentVideoIndex + 1)
        } else {
            console.log("วีดีโอนี้ดูแล้ว");
        }

    };

    const handleVideoClick = (index) => {
        // console.log(currentVideoIndex)
        if (watchedVideos.includes(index - 1) || index === 0) {
            setCurrentVideoIndex(index);
        }
    };

    // const handleProgress = () => {
    //     // console.log(currentVideoIndex)
    //     // if (currentVideoIndex === 0) {
    //     //     startCourse()
    //     // }
    //     startCourse(currentVideoIndex + 1)
    // }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    // const startCourse = async (number) => {
    //     setLoading(true)
    //     let res = await api.startCourse(groupCode, code, number)
    //     setLoading(false)
    //     if (res) {
    //         if (res['data']['code'] === 200) {
    //             // console.log(res['data'])
    //             console.log(res['data']['message'])
    //         } else {
    //             // //alert(res['data']['message'])
    //             console.log(res['data']['message'])
    //         }
    //     } else {
    //         alert('ไม่ตอบสนอง')
    //     }
    // }

    const finishLesson = async (number) => {
        setLoading(true)
        let res = await api.finishLesson(groupCode, code, registerNumber, number)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                // console.log(res['data'])
                console.log(res['data']['message'])
            } else {
                // //alert(res['data']['message'])
                console.log(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const handleClickTestAfter = () => {
        console.log(watchedVideos.length, property.length)
        if (watchedVideos.length === property.length) {
            navigate('/testAfterClass', { state: { item: location.state.item, button: '1' } })
        } else {
            alert('กรุณาเรียนให้ครบบทเรียนก่อนทำแบบทดสอบหลังเรียน')
        }
    }

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60)
        const secs = Math.floor(seconds % 60)
        return `${minutes}:${secs < 10 ? '0' : ''}${secs}`
    }

    return (
        <>
            <Loader loading={loading} />
            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gridGap: '10px'
                }}>
                    <KeyboardBackspaceIcon sx={{ fontSize: '20px' }} />
                    <Box sx={{
                        cursor: 'pointer'
                    }}
                        onClick={() => { navigate('/manageUserELearning') }}
                    >กลับไป ห้องเรียนออนไลน์</Box>
                </Box>

                <Box>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: '20px',
                        "@media (max-width: 800px)": {
                            fontSize: '18px',
                        },
                    }}>{inform['e_learning_name']}</Typography>
                </Box>

                <Box sx={{
                    display: 'flex',
                    gridGap: '10px',
                    "@media (max-width: 800px)": {
                        display: 'grid'
                    },
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}><img src={date} />สร้างเมื่อ {convertDate(inform['created_date'])}</Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}><img src={book} />จำนวน {property?.length} บทเรียน</Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}><img src={time} />เวลารวม {inform['e_learning_hour']} ชั่วโมง</Box>
                </Box>

                <Box>
                    <ReactPlayer
                        width='100%'
                        height='500px'
                        // controls
                        playing={playing}
                        onPlay={() => { setPlaying(true) }}
                        onPause={() => { setPlaying(false) }}
                        controls={false}
                        onProgress={(state) => setPlayedSeconds(state.playedSeconds)}
                        onDuration={(d) => setDuration(d)}
                        url={property[currentVideoIndex]?.attactment_files[1]['url']}
                        onEnded={handleVideoEnd}
                        // onStart={() => { handleProgress(currentVideoIndex) }}
                        onStart={() => { setShowColor(currentVideoIndex + 1) }}
                        onSeek={() => {
                            // ป้องกันการ seek
                            if (playerRef.current) {
                                playerRef.current.seekTo(playedSeconds, 'seconds') // ย้อนกลับทันที
                            }
                        }}
                    />
                    <Box sx={{
                        background: 'rgba(0, 0, 0, 0.3)',
                        padding: '15px',
                        display: 'flex',
                        alignItems: 'center',
                        borderRadius: '0 0 15px 15px'
                    }}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                            onClick={() => { setPlaying(!playing) }}
                        >
                            {playing ?
                                <PauseIcon sx={{ color: '#FFFFFF' }} />
                                :
                                <PlayArrowIcon sx={{ color: '#FFFFFF' }} />
                            }
                        </Box>
                        <Box style={{ marginLeft: '20px', color: '#FFFFFF' }}>
                            {formatTime(playedSeconds)} / {formatTime(duration)}
                        </Box>
                    </Box>
                </Box>

                <Box sx={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 2fr',
                    gridGap: '10px',
                    "@media (max-width: 800px)": {
                        gridTemplateColumns: '1fr',
                    },
                }}>
                    <Box>
                        <Box sx={{
                            border: '1px solid #478F96',
                            borderRadius: '10px',
                            padding: '10px',
                            display: 'grid',
                            gridGap: '10px'
                        }}>
                            <Typography sx={{ fontWeight: 600, color: '#478F96' }}>เอกสารประกอบการเรียน</Typography>
                            {property[currentVideoIndex]?.attactment_files[0]['url'] ?
                                <Box sx={{
                                    cursor: 'pointer',
                                    borderRadius: '10px',
                                    boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.25)',
                                    padding: '10px'
                                }}
                                    onClick={() => { window.open(property[currentVideoIndex]?.attactment_files[0]['url']) }}
                                >
                                    {property[currentVideoIndex]?.title}
                                </Box>
                                :
                                <Box sx={{ textAlign: 'center' }}>
                                    ไม่มีเอกสารประกอบ
                                </Box>
                            }

                        </Box>

                        {inform['post_test_form']?.length > 0 || inform['pre_test_form']?.length > 0 ?
                            <Box sx={{
                                border: '1px solid #478F96',
                                borderRadius: '10px',
                                padding: '10px',
                                marginTop: '10px'
                            }}>
                                <Typography sx={{ fontWeight: 600, color: '#478F96' }}>แบบประเมิน</Typography>
                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr',
                                    gridGap: '10px',
                                }}>
                                    {inform['pre_test_form'].length > 0 ?
                                        <Button variant='contained' sx={{ cursor: 'default' }} >
                                            ก่อนเรียน
                                        </Button>
                                        : ''
                                    }
                                    {inform['post_test_form'].length > 0 ?
                                        <Button variant='outlined' onClick={() => { handleClickTestAfter() }}>
                                            หลังเรียน
                                        </Button>
                                        : ''
                                    }
                                </Box>
                            </Box>
                            :
                            <></>
                        }
                    </Box>

                    <Box>
                        <Box sx={{
                            border: '1px solid #478F96',
                            borderRadius: '10px',
                            display: 'grid',
                            gridGap: '10px',
                            padding: '10px'
                        }}>
                            <Typography sx={{ fontWeight: 600, color: '#478F96' }}>รายละเอียดบทเรียน</Typography>

                            <Box sx={{ color: '#49BBBD' }}>{complete} / {property.length} COMPLETED</Box>

                            <Box sx={{ width: '100%', height: '5px', display: 'grid', gridTemplateColumns: `repeat(${property.length}, 1fr)`, gridGap: '16px' }}>
                                {property.map((item, index) => (
                                    <Box key={index} sx={{ height: '100%', width: '100%', borderRadius: '5px', bgcolor: complete > index ? '#49BBBD' : '#D1EEEF' }}></Box>
                                ))}
                            </Box>

                            <Box sx={{ display: 'grid', gridGap: '10px' }}>
                                {property.map((item, index) => (
                                    <Box sx={{
                                        border: '1px solid #C8EBEB',
                                        borderRadius: '10px',
                                        padding: '5px',
                                        backgroundColor: showColor > index || complete > index ? '#C8EBEB' : '#ffffff',
                                        cursor: !watchedVideos.includes(index - 1) && index !== 0 ? 'auto' : 'pointer',
                                    }}
                                        key={index}
                                        onClick={() => handleVideoClick(index)}
                                        disabled={!watchedVideos.includes(index - 1) && index !== 0}
                                    >
                                        <Box sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}>
                                            {/* <Typography sx={
                                                open[index] ? { color: '#478F96', fontWeight: 600, fontSize: '18px' }
                                                    : { color: '#252641', fontWeight: 600, fontSize: '18px' }
                                            }>บทที่ {index + 1}</Typography>
                                            <img
                                                src={arrow}
                                                style={open[index] ? { transform: 'rotate(180deg)', cursor: 'pointer', width: '20px' } : { cursor: 'pointer', width: '20px' }}
                                                onClick={() => { toggle(index) }}
                                            /> */}
                                            <Typography sx={{ color: '#478F96', fontWeight: 600, fontSize: '18px' }}>บทที่ {index + 1}</Typography>
                                        </Box>
                                        <Box sx={{ color: '#252641' }} >{item['title']}</Box>
                                        {/* {!open[index] ?
                                            <></>
                                            :
                                            <Box
                                                sx={{
                                                    // cursor: 'pointer',
                                                    cursor: !watchedVideos.includes(index - 1) && index !== 0 ? 'auto' : 'pointer',
                                                    color: complete > index ? '#478F96' : '#252641'
                                                }}
                                                onClick={() => handleVideoClick(index)}
                                                disabled={!watchedVideos.includes(index - 1) && index !== 0}
                                            >{item['title']}</Box>
                                        } */}
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Box>

                </Box>

            </Box>
        </>
    )
}

export default Classroom
